module.exports = __webpack_public_path__ + "img/33.24aa75fd.png";